// placeholder function to return a dummy secret (while backend is built to handle this).
export const generateWebhookSecret = (): string => {
  const random = crypto.randomUUID().replace(/-/g, '').slice(0, 32);

  return `whsec_${random}`;
};
